/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
export default {
  init() {
    $("#ui-modal").on("show.bs.modal", function (event) {
      var button = $(event.relatedTarget);
      var slideContent = $(button.data("content"));
      var modalImageList = $(".modal-image-content", slideContent);
      var modalContent = $(".modal-product-content", slideContent);

      var modal = $(this);
      modalImageList
        .children()
        .clone(true, true)
        .appendTo(modal.find(".modal-image"));
      modalContent
        .children()
        .clone(true, true)
        .appendTo(modal.find(".modal-information"));
      $(".carousel", modal).carousel();
    });
    $("#ui-modal").on("hidden.bs.modal", function (event) {
      var modal = $(this);
      $(".modal-image", modal).html("");
      $(".modal-information", modal).html("");
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/templatePromotions.js